import { Dataset } from '../../types/types';

// Minimal shape we actually read from a dataset item — avoids `any`
// while still tolerating the loosely-typed `Dataset.items`.
//TODO: create proper Dataset.items type
type DatasetItemLike = {
  name?: string;
  visible?: boolean;
};

/**
 * Minimal items list for the control-action prefetch (`fetchNeededDatasetData`).
 *
 * Why: downstream of the prefetch we only read `row[idItem]` (request bodies)
 * and `row[labelItem]` (confirm-modal text). Fetching the full visible-items
 * set via `getItemsParamArray` is wasteful here. When `labelItem` is
 * undefined we fall back to the first visible item's name — same rule as
 * `useControlActionModalContent.getLabelParam`, so the confirm modal's
 * `%s` substitution keeps working.
 */
export const getControlActionItems = (dataset: Dataset): string[] => {
  const items: string[] = [];

  if (dataset.idItem) {
    items.push(dataset.idItem);
  }

  if (dataset.labelItem) {
    if (!items.includes(dataset.labelItem)) {
      items.push(dataset.labelItem);
    }
    return items;
  }

  // No labelItem — mirror the confirm-modal fallback: first visible item's name.
  const datasetItems: DatasetItemLike[] = Array.isArray(dataset.items)
    ? (dataset.items as DatasetItemLike[])
    : [];
  const fallback = datasetItems.find((item) => item.visible !== false);
  if (fallback?.name && !items.includes(fallback.name)) {
    items.push(fallback.name);
  }

  return items;
};
